<template>
  <div class="page">
    <panel
      v-if="noJump"
      :extinfo="extinfo"
      ref="panel"
      :wapTitle="''"
      :appLink="appLink"
      :spreadID="'0'"
      :showNav="false"
      :isDetail="false"
      @gotoApp="gotoApp"
    ></panel>
    <header v-if="noJump" class="header greenHeader">
      <a
        href="javascript:;"
        class="goBack"
        @click="goBack()"
        v-if="!isWx && !from"
      ></a>
      <div
        @click.stop="followFun(info)"
        class="followBox"
        :style="
          info && info.isFocus == 0 ? 'color: #6B6C6C;' : 'color: #F6344B;'
        "
      >
        <img
          v-if="info && info.isFocus == 1"
          src="../../assets/img/Component 22@2x.png"
        />
        <img
          v-if="info && info.isFocus == 0"
          src="../../assets/img/Component 21@2x.png"
        />
      </div>
      <span
        class="icon_share"
        @click="alertInfo"
        v-if="!isWx && from != 1"
      ></span>
      <h3></h3>
    </header>
    <!-- App 内的占位块：浏览器里这个位置是下面那个 .header.greenHeader（返回/标题/分享，同样 2.2rem），
         App 里这些控件由原生导航栏提供，所以只留一个同高的空块把版面顶下来。
         不要给它背景色：原先涂的 #35BD7D 会从 .topBg 的 blur(10px) 羽化边缘透出来，
         在头图上方形成一条突兀的绿带。留空之后这里自然是头部背景图的延续。
         也不要直接删掉这个块 —— 少了这 2.2rem，拍行 logo 卡片会贴到 webview 顶边。 -->
    <header v-if="!noJump" style="height: 2.2rem; width: 100%"></header>
    <!-- 2.3 头部背景图 top_bg_pic：后端已取图缩放；空串时回落到 CSS 默认图(Group437) -->
    <div
      class="topBg"
      :style="[
        !noJump ? { height: topBgAppHeight || '5rem' } : {},
        (info && info.top_bg_pic) ? { backgroundImage: 'url(' + info.top_bg_pic + ')' } : {}
      ]"
    ></div>
    <div class="speDetail" @click="toSessionDetail">
      <div class="speName">{{ sessName }}</div>

      <div class="speInfo">
        <div v-for="(item, index) in sessData" :key="index">
          <span class="moreBtn" v-if="index == 1"></span>
          <p>{{ item.label }}：{{ item.text }}</p>
        </div>
      </div>
      <div class="imgCenter">
        <div class="bg">
          <img style="filter: blur(10px);" :src="picUrl" :onerror="errImg" />
        </div>
        <div class="poster">
          <img :src="picUrl" :onerror="errImg" />
        </div>
      </div>
    </div>
    <!-- 位置1：导览直播模块（preview_tour_list 非空才整块渲染；1 张宽卡 / 多张横滑窄卡）-->
    <div
      class="previewTourModule"
      v-if="info.preview_tour_list && info.preview_tour_list.length"
    >
      <div
        class="previewTourScroll"
        :class="{ 'is-single': info.preview_tour_list.length === 1 }"
      >
        <div
          v-for="(tour, tIdx) in info.preview_tour_list"
          :key="'tour' + tIdx"
          class="previewTourCard"
          @click="onTourCardClick(tour, tIdx)"
        >
          <div class="previewTourCard__cover">
            <!-- 封面缺失/坏链（实测 tour_cover_pic 会下发 404 的非空 URL）时隐藏 img，
                 露出容器深色底；白底默认图放在深色卡上会很突兀 -->
            <img
              v-if="tour.tour_cover_pic"
              :src="tour.tour_cover_pic"
              :onerror="tourCoverErr"
              alt=""
            />
          </div>
          <div class="previewTourCard__main">
            <span
              v-if="tourHasBadge(tour)"
              class="previewTourCard__badge"
            >
              <!-- 音浪只在「直播中」出现；暂停中(3) 只留红色文字标签，不带动效图标
                   （实机调试结论，与首页/资讯页/拍行视频页保持一致） -->
              <i
                v-if="tourLiveStatus(tour) === 2"
                class="previewTourCard__bars"
                aria-hidden="true"
              ><em></em><em></em><em></em></i>
              <span>{{ tourBadgeText(tour) }}</span>
            </span>
            <div
              class="previewTourCard__title"
              :class="{ 'is-clamp2': !isSingleTour && !isTourNoticeBtn(tour) }"
            >{{ tour.tour_title }}</div>
            <div class="previewTourCard__time" v-if="tourSubText(tour)">
              {{ tourSubText(tour) }}
            </div>
            <div
              v-if="!isSingleTour && isTourNoticeBtn(tour)"
              class="previewTourCard__btn"
              @click.stop="onTourButtonClick(tour, tIdx)"
            >{{ tourBtnText(tour) }}</div>
          </div>
          <div
            v-if="isSingleTour && isTourNoticeBtn(tour)"
            class="previewTourCard__btn previewTourCard__btn--side"
            @click.stop="onTourButtonClick(tour, tIdx)"
          >{{ tourBtnText(tour) }}</div>
        </div>
      </div>
    </div>
    <!-- <div class="specialSubjectBox" v-if="info.article_list.length>0">
        <div class="subjectBox">
            <div class="subjectContentBox">
                <div class="subjectImg">
                    <img :src="info.article_list[0].cover" alt="">
                </div>
                <div class="subjectTextBox">
                    <div>{{info.article_list[0].title}}</div>
                    <div class="num">{{info.article_list[0].view_num}}阅读</div>
                </div>
            </div>
        </div>

    </div> -->
    <div
      class="statistics"
      v-if="(info.special_total && info.special_total != '') || showSpecialTab"
    >
      <!-- 「共X场」：数字加粗置黑，其余 #353637（安卓 highlightSpecialTotal 用 SpannableString 做，
           H5 走 v-html + 同样的 \d+ 正则包 <b>；special_total 是后端下发的短文案，
           已在 specialTotalHtml 里做过转义，不会有 XSS 面） -->
      <span class="statistics-total" v-html="specialTotalHtml"></span>
      <!-- 专场状态筛选：全部 / 近期可拍 / 已结拍。
           显隐由后端 show_special_tab 决定（状态一致时不下发），前端不自己判断状态是否一致；
           文案与计数一律用 special_tab_list 下发的 name/count，不写死也不自己数。
           **三个 tab 固定渲染**：后端漏发某个 tab 时用兜底文案 + (0)，对齐安卓
           bindFilterTab(tvFilterAll/Recent/Ended, tabList.firstOrNull{...}, "全部"/…)——
           安卓那三个 TextView 是写死在布局里的，不是按下发列表动态生成。
           切 tab 只做本地过滤，不重新请求接口。 -->
      <div class="special-filter" v-if="showSpecialTab">
        <span
          v-for="tab in specialFilterTabs"
          :key="'specialTab' + tab.tab_type"
          class="special-filter__item"
          :class="{ 'is-active': specialTabActive === tab.tab_type }"
          @click="onSpecialTabChange(tab)"
          >{{ tab.text }}</span
        >
      </div>
    </div>
    <!-- 专场筛选 tab 排查面板：只在 URL 带 ?debug=1 时出现（临时，定位完连同 computed 里的
         debugOn/debugTabInfo 一起删）。把接口原样返回的字段摆出来，用来区分"前端没做"和"后端没下发"。 -->
    <div class="tab-debug" v-if="debugOn">
      <div class="tab-debug__title">专场筛选 tab 排查（?debug=1 才显示）</div>
      <div class="tab-debug__row" v-for="row in debugTabInfo" :key="row.k">
        <b>{{ row.k }}</b><span>{{ row.v }}</span>
      </div>
    </div>
    <div class="onlineAuction" v-if="isShowOnline">
      <div class="auctionView" @click="onlineClick">
        <span class="auctionTitle">{{ onlineTitle }}</span>
        <span class="auctionBtn"
          >参拍 | <i v-if="onlinePerson">| {{ onlinePerson }}次围观</i></span
        >
      </div>
    </div>

    <div class="speList">
      <ul>
        <li
          @click="toSpecial(item, index)"
          v-for="(item, index) in filteredSessList"
          :key="index"
        >
          <dl>
            <dt>
              <div class="imgCenter">
                <span
                    :class="[
                      'auction-top-tag',
                      item.bid_type === 1 ? 'tag-tongbu' : '',
                      item.bid_type === 2 ? 'tag-xianshi' : '',
                      item.bid_type === 4 ? 'tag-zhibo' : '',
                    ]"
                  ></span>
                <!-- <img src="../../assets/img/avator.jpeg" alt="" /> -->
                <img :src="item.coverPic || pictureDefault" alt="" />
               <span   v-if="item.cultural_license != ''&&item.bid_type != 0 && (item.bid_type == 2 || item.bid_type == 4)" class="wenwubaopi_icon"></span>
              </div>
              <!-- <span class="num">{{ item.total }}</span> -->
              <span class="HDPic" v-if="item.isHD > 0"></span>
          
            </dt>
            <dd>  
              <h3>
                <!--5-结拍 4-拍卖中  3-带预展 2-预展中 1-待拍卖-->
                <!-- 此处没有加上预展状态 -->
                <!-- <span :class="status status1"></span -->
                <span
                  :class="[
                    'status',
                    item.status == 1 ? 'status1' : '',
                    item.status == 4 ? 'status2' : '',
                    item.status == 5 ? 'status3' : '',
                    item.status == 2 ? 'status4' : '',
                    item.status == 3 ? 'status5' : '',
                    item.status == 6 ? 'status6' : '',
                  ]"
                  >{{ item.status == 6 ? "暂停中" : "" }}</span
                >{{ item.name }}
              </h3>
              <div class="tags">
                <template v-for="(e, index) in item.live_info.label_list">
                  <template v-if="e.name == '同步拍'">
                    <img :key="'tag' + index" class="bidIcon" src="@/assets/img/bid_type_r.png" alt="">
                  </template>
                  <template v-else-if="e.name == '限时拍'">
                    <img :key="'tag' + index" class="bidIcon" src="@/assets/img/bid_type_b.png" alt="">
                  </template>
                  <template v-else-if="e.name == '直播拍'">
                    <img :key="'tag' + index" class="bidIcon" src="@/assets/img/bid_type_c.png" alt="">
                  </template>
                  <template v-else-if="e.style == 1">
                    <span
                      :key="'tag' + index"
                      :class="e.detail != '' ? (String(e.detail || '').length >= 4 ? 'label-butie label-butieLong' : 'label-butie') : 'label-butieNull'"
                      :style="e.detail && e.detail.length < 3 ? 'width: 2rem;' : ''"
                      @click.stop="handleLabelClick(e,item)"
                    >
                      <i v-if="e.detail != ''">{{ e.detail }}</i>
                    </span>
                  </template>
                  <template v-else-if="e.style == 11">
                    <span
                      :key="'tag' + index"
                      :class="e.max_organ_ratio != '' ? (String(e.max_organ_ratio || '').length >= 4 ? 'label-butie2 label-butie2Long' : 'label-butie2') : 'label-butie2Null'"
                      :style="e.max_organ_ratio && e.max_organ_ratio.length < 3 ? 'width: 2rem;' : ''"
                      @click.stop="handleLabelClick(e,item)"
                    >
                      <i v-if="e.max_organ_ratio != ''">{{ e.max_organ_ratio }}</i>
                    </span>
                  </template>
                  <template v-else-if="e.style == 0">
                    <span :key="'tag' + index" class="label-baozhengjin">{{ e.name }}</span>
                  </template>
             
                  <template v-else-if="e.style == 10">
                    <span :key="'tag' + index" class="nullBean_icon"></span>
                  </template>
                  <template v-else-if="e.style == 12">
                    <span :key="'tag' + index" class="tagStyle3" @click.stop="handleLabelClick(e,item)"></span>
                  </template>
                  <template v-else-if="e.style == 13">
                    <span :key="'tag' + index" class="tagStyle4" @click.stop="handleLabelClick(e,item)"></span>
                  </template>
                  <template v-else-if="e.style == 9">
                    <beanBtn  
                      :key="'tag' + index"
                      :name="e.name"
                      :isAbsolute="false"
                      @click.native.stop="handleLabelClick(e,item)" 
                    ></beanBtn>
                  </template> 
                  <template v-else>
                    <span :key="'tag' + index">
                      {{ e.name }}
                    </span>
                  </template>
                </template>
              </div>

              <div
                class="speItem"
                v-for="(item1, index1) in item.extraInfo"
                :key="index1"
              >
                <p :class="['item', 'icon' + Number(++index1)]">
                  {{ item1.text }}
                </p>
              </div>
            </dd>
          </dl>
          <!-- 直播入口（live_bar 数组：每条 = 一种直播形态，导览/拍卖各一行）-->
          <div class="liveEntryList" v-if="item.live_bar && item.live_bar.length">
            <template v-for="(bar, liveIdx) in item.live_bar">
              <!-- 只弹窗(button_type=5)：按钮整个收起，改成整条可点。
                   注意不能用 @click.stop —— 那会把非只弹窗态下「点直播条空白处冒泡到
                   专场卡跳详情」的原行为一起掐掉，冒泡只在只弹窗态里手动阻止。 -->
              <div
                class="liveEntry"
                :key="'live' + liveIdx"
                @click="onLiveEntryRowClick(bar, item, $event)"
              >
                <div class="liveEntry__left">
                  <div class="liveEntry__title">
                    <span class="liveEntry__name">{{ bar.live_type_name }}</span>
                    <span
                      class="liveEntry__tag"
                      :class="liveBarTagClass(bar)"
                      v-if="liveBarTagText(bar)"
                    >
                      <i v-if="bar.live_status === 2" class="liveEntry__tagBars" aria-hidden="true">
                        <em></em><em></em><em></em>
                      </i>
                      <span class="liveEntry__tagText">{{bar.status_name }}</span>
                    </span>
                  </div>
                  <div class="liveEntry__time" v-if="bar.start_time">
                    <img class="liveEntry__clock" src="@/assets/img/icon_clock.png" alt="" />
                    <span>{{ bar.start_time }}</span>
                  </div>
                </div>
                <div
                  v-if="!isEndPopup(bar)"
                  class="liveEntry__btn"
                  :class="{ 'is-subscribed': liveBarBtnSubscribed(bar) }"
                  @click.stop="onLiveBarClick(bar,item)"
                >{{ liveBarBtnText(bar) }}</div>
              </div>
              <div class="liveEntry__divider" :key="'divider' + liveIdx" v-if="liveIdx < item.live_bar.length - 1"></div>
            </template>
          </div>
        </li>
      </ul>
    </div>
    <div class="noMore">
      <span>我是有底线的</span>
    </div>
    <div class="podWrap" @click="podSc()">
      <contact :info="info" :id="sessionCodeId"></contact>
    </div>
    <DownLoadApp ref="downloadPop"></DownLoadApp>
    <watermark v-if="showWater"></watermark>
    <beanInstructionsPop 
          v-if="showBeanPop" 
          :type="beanInstructionsPopType"
          :combinationStyle="combinationStyle"
          :ratio="ratio"
          :commission_total_ratio="commission_total_ratio"
          :max_organ_ratio="max_organ_ratio"
          :max_user_ratio="max_user_ratio"
          scPageIndex="33"
          @close="handleBeanPopClose"
        ></beanInstructionsPop>
    <SelectReminderMethodDialog
      :visible="reminderDialog.visible"
      :initial-global="reminderDialog.initialGlobal"
      :voice-tips="reminderDialog.voiceTips"
      :system-notify-on="reminderDialog.systemNotifyOn"
      @save="onReminderDialogSave"
      @close="onReminderDialogClose"
      @open-system-settings="onReminderDialogOpenSystemSettings"
    />
    <!-- 0918「显示只弹窗」：button_type=5 的直播入口点击后的提示 -->
    <liveEndedDialog
      :visible.sync="liveEnded.visible"
      :popup="liveEnded.popup"
    />
  </div>
</template>

<script>
import { sessionDetail, setBidClick } from "@/api/auction";
import { indexFocus, addSpeRemind, cancelSpeRemind } from "@/api/index";
import { mapActions, mapGetters } from "vuex";
import { alertInfo, getWXConfig } from "@/assets/js/weixinShare";
import panel from "@/views/preview/component/panel.vue";
import DownLoadApp from "@/components/common/downloadApp";
import contact from "@/components/contact";
import { isWeixin } from "@/api/auction/isWeixin";
import watermark from "@/components/common/watermark";
import { Toast } from "vant";
import { scMdFunc, gotoLogin } from "@/assets/js/scData";
import beanInstructionsPop from "@/components/bean/instructionsPop";
import beanBtn from "@/components/bean/btn";
import SelectReminderMethodDialog from "@/components/reminder/SelectReminderMethodDialog";
import liveEndedDialog from "@/components/common/liveEndedDialog";
import { decideDialog, saveReminderSwitch } from "@/utils/reminderGate";
import Cookies from "js-cookie";
import pictureDefault from "@/assets/img/home_picture_default@2x.png";
export default {
  name: "session",
  metaInfo() {
    const sm = (this.info && this.info.shareMessage) || {}
    return {
      meta: [
        { property: 'og:title', content: sm.title || '' },
        { property: 'og:image', content: sm.pic || 'https://pubunder.artron.net/pubimgs/m/wxImgAuc.png' },
        { property: 'og:description', content: sm.desc || '' },
      ]
    }
  },
  data() {
    return {
      pictureDefault,
      // 0918「显示只弹窗」：button_type=5 的入口点击后弹「当前直播已结束」
      liveEnded: { visible: false, popup: null },
      reminderDialog: {
        visible: false,
        initialGlobal: { voice: 0, sms: 0, push: 0 },
        voiceTips: '',
        systemNotifyOn: true
      },
      pendingRemind: null,
      showBeanPop: false,
      beanInstructionsPopType:1,
      combinationStyle:'',
      ratio:'',
      commission_total_ratio:'',
      max_organ_ratio:'',
      max_user_ratio:'',
      waterLink: "",
      noJump: true,
      errImg:
        'this.src = "' + require("../../assets/img/topic/default.png") + '"',
      // 导览卡是深色卡，封面坏链时不换白底默认图，直接隐藏露出容器深色底
      tourCoverErr: 'this.style.display="none"',
      from: this.$route.query.from,
      showWater: false,
      sessData: null, //整个的返回值
      // App 内 .topBg 的实测高度，见 syncTopBgHeight()。空串时回落到原来的 5rem
      topBgAppHeight: "",
      // 专场状态筛选当前选中的 tab_type：1 全部 / 2 近期可拍 / 3 已结拍。
      // 0 表示还没被接口的 default_tab_type 初始化过（下拉刷新时用它区分"首次"与"用户已选"）
      specialTabActive: 0,
      sessName: "",
      sessList: [], //拍卖会列表
      picUrl: "", //图片
      appLink: "/2/3/" + this.$route.params.sessionCode,
      sessionCodeId: this.$route.params.sessionCode,
      isWx: false,
      extinfo: "",
      param: {
        show: 0,
        sessionCode: "",
        // session_inspect_id: null,
        only_meta: 1, //0-全部都拿数据 1-只拿mate 基本信息 2-只拿列表
        // 专场筛选默认 tab 的入口来源（1 近期可拍 / 2 已结拍 / 0 其他），请求前由 tab_from 赋值。
        // 这里先声明出来是为了让它可响应——Vue 2 对后加的属性不会建响应，排查面板读不到。
        from: 0,
      },
      info: {
        isFocus: "",
        article_list: [],
      },
      onlineTitle: "",
      onlineUrl: "",
      isShowOnline: false,
      companyName: "",
      onlinePerson: 0,
    };
  },
  created() {
    this.waterLink = "";
    // 判断下载app的是否显示
    if (this.$route.query.from && this.from == 1) {
      this.noJump = false;
    }
  },
  mounted() {
    var isTuluApp = /(SwiftTuLu|ArtronTulu|HarmonyOSTulu)/g.test(
      window.navigator.userAgent
    );
    var isToutiaoApp = /(SwiftToutiao|ArtronToutiao|ArtExpress)/g.test(
      window.navigator.userAgent
    );
    if (isTuluApp || isToutiaoApp) {
      this.noJump = false;
    }
    if (
      (this.$route.query.from && this.$route.query.from == 1) ||
      (this.$route.query.from && this.$route.query.from == 2)
    ) {
      this.showWater = true;
      this.waterLink = this.$route.query.from;
    }
    if (isWeixin()) {
      this.isWx = true;
    }
    // console.log("this.getIsLoadIng", this.getIsLoadIng);
    // //接口调用
    if (!this.getIsLoadIng) {
      this.param.sessionCode = this.$route.params.sessionCode;
      this.param.only_meta = 1;
      if (this.$route.query.from && this.$route.query.from == 1) {
        this.param.show = 1;
        this.param.session_inspect_id = Number(this.$route.query.sessiion_inspect_id);
      }
      this.getSessionDetail([
        this.param,
        () => {
          this.filteData();
        },
      ]);
    } else {
      this.param.sessionCode = this.$route.params.sessionCode;
      this.param.only_meta = 1;

      this.filteData();
    }
    let that = this;
    that.extinfo = JSON.stringify({
      url: "session",
      param: that.$route.params.sessionCode,
    });
    // this.getOnLineAuction();

    // 头部背景高度：首屏先算一次，旋转/尺寸变化时重算（非响应式字段存句柄，beforeDestroy 里摘）
    this.$nextTick(this.syncTopBgHeight);
    this._topBgResizeHandler = () => this.syncTopBgHeight();
    window.addEventListener("resize", this._topBgResizeHandler);
    window.addEventListener("orientationchange", this._topBgResizeHandler);
  },
  // 每次重渲染后校准头部背景高度。数据是异步来的（标题、信息行数都会变），
  // 挂在 updated 上就不用去追每一个赋值点。syncTopBgHeight 内部只在值真的变了才写，
  // 否则会 updated → setData → updated 死循环
  updated() {
    this.syncTopBgHeight();
  },
  beforeDestroy() {
    // 组件销毁标记 + 清理定时器：异步回调（订阅提醒/取消提醒/decideDialog）在页面已离开时不再写状态、不再弹 Toast
    this._destroyed = true;
    if (this._onlineTimer) {
      clearTimeout(this._onlineTimer);
      this._onlineTimer = null;
    }
    if (this._topBgResizeHandler) {
      window.removeEventListener("resize", this._topBgResizeHandler);
      window.removeEventListener("orientationchange", this._topBgResizeHandler);
      this._topBgResizeHandler = null;
    }
  },

  //服务端渲染
  asyncData({ store, route }) {
    var param = {};
    if (route.query.from && route.query.from == 1) {
      param = {
        sessionCode: route.params.sessionCode,
        only_meta: 1, //取mate信息
        show: 1,
        session_inspect_id: Number(route.query.sessiion_inspect_id),
      };
    } else {
      param = {
        sessionCode: route.params.sessionCode,
        only_meta: 1, //取mate信息
      };
    }

    return store.dispatch("sessionPage/getSessionDetail", [
      param,
      null,
      () => {},
    ]);
  },
  computed: {
    ...mapGetters({
      getIsLoadIng: "sessionPage/getIsLoadIng",
      getData: "sessionPage/getData",
    }),
    // 后端下发的筛选 tab 列表：[{ tab_type: 1|2|3, name, count }]，show_special_tab=0 时为空数组
    specialTabList() {
      const list = this.info && this.info.special_tab_list;
      return Array.isArray(list) ? list : [];
    },
    // 是否显示筛选栏。**只认后端的 show_special_tab + 列表非空**，与安卓
    // `if (showSpecialTab != 1 || tabList.isNullOrEmpty()) GONE` 逐字对齐。
    // "专场状态是否一致"由后端判定并做了版本门控，前端自己数 status 会和后端口径打架
    //（status 边界比看上去多：6 暂停归近期可拍、非正常结拍会回落成 4 拍卖中）。
    // ⚠️ 这里一度多加了 length > 1 的"防御"，安卓没有这条——后端只下发 1 个 tab 时
    // 安卓照样显示三个（另两个 (0)），H5 却整条藏掉，两端就不一致了，已移除。
    showSpecialTab() {
      return (
        Number(this.info && this.info.show_special_tab) === 1 &&
        this.specialTabList.length > 0
      );
    },
    // 固定三个 tab（1 全部 / 2 近期可拍 / 3 已结拍），文案与计数优先用后端 special_tab_list 里
    // 对应 tab_type 的 name/count，后端没给这一项时用兜底名 + (0)。
    // 对齐安卓 bindFilterTab：`val name = tab?.name?.takeIf{it.isNotEmpty()} ?: fallbackName`
    // + `tv.text = "$name(${tab?.count ?: 0})"`。
    specialFilterTabs() {
      const fallback = [
        { tab_type: 1, name: "全部" },
        { tab_type: 2, name: "近期可拍" },
        { tab_type: 3, name: "已结拍" },
      ];
      return fallback.map((f) => {
        const hit = this.specialTabList.filter(
          (t) => Number(t && t.tab_type) === f.tab_type
        )[0];
        const name = (hit && hit.name) || f.name;
        const count = hit && hit.count !== undefined && hit.count !== null ? hit.count : 0;
        return { tab_type: f.tab_type, text: name + "(" + count + ")" };
      });
    },
    // 「共X场」里的数字加粗置黑（安卓 highlightSpecialTotal：\d+ 加 BOLD + 黑色）。
    // special_total 来自接口，先转义再包 <b>，避免 v-html 把后端字符串当标签解析。
    specialTotalHtml() {
      const raw = this.info && this.info.special_total;
      if (!raw && raw !== 0) return "";
      const esc = String(raw)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
      return esc.replace(/\d+/g, '<b class="statistics-num">$&</b>');
    },
    // 按当前 tab 本地过滤专场；切 tab 不重新请求接口。
    // 过滤依据是后端给的 specialsList[].tab_type，不要用 status 自己判断。
    filteredSessList() {
      const list = this.sessList || [];
      // 不显示筛选栏、或选中"全部"(1)、或还没初始化(0) → 原样返回，行为与改动前一致
      if (!this.showSpecialTab || !this.specialTabActive || this.specialTabActive === 1) {
        return list;
      }
      return list.filter(
        (item) => Number(item && item.tab_type) === this.specialTabActive
      );
    },
    // 位置1 导览模块：1 张=宽卡(按钮在右)，多张=窄卡横滑(按钮在文字列下方整行)
    isSingleTour() {
      const list = this.info && this.info.preview_tour_list
      return !!(list && list.length === 1)
    },
    /* ---- 专场筛选 tab 的排查面板（临时，定位完删）----
       只在 URL 带 ?debug=1 时渲染，普通用户/爬虫看不到。
       解决的问题：App 能看到 tab、H5 看不到时，肉眼分不清是"前端没做"还是"后端没下发"。
       把接口原样返回的几个字段摆出来，一眼就能判：
         show_special_tab=0 → 后端没开，前端不显示是对的；
         =1 但 special_tab_list 只有 1 项 → 前端的 length>1 防御把它挡了；
         =1 且 tab 有多项却还是不显示 → 那才是前端的问题。 */
    debugOn() {
      const q = this.$route && this.$route.query;
      return !!(q && (q.debug === "1" || q.debug === 1));
    },
    debugTabInfo() {
      const info = this.info || {};
      const list = this.sessList || [];
      const tabTypeCount = {};
      const statusCount = {};
      list.forEach((s) => {
        const t = s && s.tab_type;
        const st = s && s.status;
        tabTypeCount[t] = (tabTypeCount[t] || 0) + 1;
        statusCount[st] = (statusCount[st] || 0) + 1;
      });
      return [
        { k: "接口", v: "POST https://api.artron.net/v3/session/detail" },
        { k: "sessionCode", v: String(this.param && this.param.sessionCode) },
        { k: "URL 上的 tab_from", v: String((this.$route && this.$route.query.tab_from) || "(没带)") },
        { k: "发给接口的 from", v: String(this.param && this.param.from) },
        { k: "show_special_tab", v: JSON.stringify(info.show_special_tab) },
        { k: "default_tab_type", v: JSON.stringify(info.default_tab_type) },
        { k: "special_tab_list", v: JSON.stringify(info.special_tab_list) },
        { k: "specialsList 条数", v: String(list.length) },
        { k: "各专场 tab_type 分布", v: JSON.stringify(tabTypeCount) },
        { k: "各专场 status 分布", v: JSON.stringify(statusCount) },
        { k: "前端算出的 showSpecialTab", v: String(this.showSpecialTab) },
        { k: "当前选中 specialTabActive", v: String(this.specialTabActive) },
        {
          k: "实际渲染的三个 tab",
          v: this.specialFilterTabs.map((t) => t.text).join("  "),
        },
        {
          k: "判定",
          v:
            Number(info.show_special_tab) !== 1
              ? "后端没下发（show_special_tab≠1）→ 不显示筛选栏是正确行为，需后端开启"
              : this.specialTabList.length === 0
              ? "show_special_tab=1 但 special_tab_list 是空的 → 后端数据不完整，仍不显示"
              : "后端已下发 → 筛选栏应当显示（固定三个 tab，后端没给的那个显示 (0)）",
        },
      ];
    },
  },
  methods: {
    /**
     * 校准 App 内 .topBg（头部深色背景）的高度。
     *
     * 背景：头部那几行文字是白色的，可读性完全依赖 .topBg 的背景图 + .topBg::after 的黑色渐变。
     * 浏览器里 .topBg 是 CSS 写死的 13.5rem，App 里模板又内联覆盖成 5rem —— 两个都是按
     * “1 行标题 + 4 行信息”凑出来的魔数。App 少了 <panel> 下载条（约 5.4rem），所以才要调小，
     * 但 5rem 调过头了：实测背景只到 98px，而 .speDetail 的文字排到 155px，
     * 「拍卖时间 / 拍卖地点」两行直接掉到背景外面，白字压白底，等于隐形。
     * 标题一旦折行、信息行数一变，魔数还会再次失配，所以这里按实际布局量。
     *
     * 只处理 App 分支（!noJump）：浏览器路径一个字节都不动，避免动到没法真机验证的场景。
     */
    // 切换专场状态筛选。纯本地过滤，不重新请求接口。
    // 切完滚回页面顶部：安卓 renderFilteredList → adapterResetData 里有
    // `rvList.layoutManager.scrollToPosition(0)`，而那个 rv 的 item0 就是包含筛选条的头部，
    // 等价于 H5 把窗口滚到顶。不滚的话，从长列表底部切到只剩两条的 tab 会停在空白处。
    onSpecialTabChange(tab) {
      const type = Number(tab && tab.tab_type);
      if (!type || type === this.specialTabActive) return;
      this.specialTabActive = type;
      if (typeof window !== "undefined") {
        this.$nextTick(() => window.scrollTo(0, 0));
      }
    },
    // 当前 tab 下还剩几个专场（按后端给的 tab_type 数，不看 status）。
    // 对齐安卓 filteredCount：全部=全量，其余按 tab_type 计数。
    countSpecialsByTab(type) {
      const list = this.sessList || [];
      if (Number(type) === 1) return list.length;
      return list.filter((item) => Number(item && item.tab_type) === Number(type)).length;
    },
    syncTopBgHeight() {
      if (typeof window === "undefined" || this.noJump || this._destroyed) return;
      const root = this.$el;
      if (!root || !root.querySelector) return;
      const bg = root.querySelector(".topBg");
      const detail = root.querySelector(".speDetail");
      if (!bg || !detail) return;

      // 背景至少要盖住白字块；下方的白色面板（.statistics）如果在，就正好收在它上沿，
      // 免得深色背景从面板底下露出来
      const top = bg.getBoundingClientRect().top;
      const panel = root.querySelector(".statistics");
      const bottom = Math.max(
        detail.getBoundingClientRect().bottom,
        panel ? panel.getBoundingClientRect().top : 0
      );
      const height = Math.round(bottom - top);
      if (!(height > 0)) return;

      const next = height + "px";
      // 必须比对后再写：这个方法由 updated 调用，无条件赋值会 updated → setData → updated 死循环
      if (this.topBgAppHeight !== next) {
        this.topBgAppHeight = next;
      }
    },
    handleLabelClick(item,partitem){
      // 允许触发弹窗的 style：9 雅昌豆 / 1 雅昌平台补贴 / 11 限时佣金优惠 / 12 物流券 / 13 物流券-会员
      if(item.style!==9&&item.style!==1&&item.style!==11&&item.style!==12&&item.style!==13){
        return
      }
      // style → type：1→3, 11→4, 12→5, 13→6（与 components/bean/instructionsPop.vue 模板分支对齐）
      let type = 0
            if(item.style===9){
            type = 1 
            this.combinationStyle = 'pay_return_been'
          } 
          else if(item.style===1){
            type = 3
        this.combinationStyle = (partitem && partitem.combination_style) || ''
          }  
          else if(item.style===11){
             type = 4
            this.combinationStyle = (partitem && partitem.combination_style) || ''
          }  
          else if(item.style===12){
           type = 5
            this.combinationStyle = (partitem && partitem.combination_style) || ''
          }  
          else if(item.style===13){
           type = 6
           this.combinationStyle = (partitem && partitem.combination_style) || ''
          }  
      // 物流券（12/13）与雅昌豆（9）不依赖 max_user_ratio；仅 style 1/11 必须有比例
      const ratioRequired = item.style===1||item.style===11
      if(ratioRequired && (!partitem.live_info||!partitem.live_info.max_user_ratio)){
        return
      }
      if(partitem && partitem.live_info){
        this.ratio = partitem.live_info.max_user_ratio
        this.commission_total_ratio=  partitem.live_info.commission_total_ratio
        this.max_organ_ratio=  partitem.live_info.max_organ_ratio
        this.max_user_ratio=  partitem.live_info.max_user_ratio
      }
     
      this.showBeanPop = true
      this.beanInstructionsPopType = type
    },
    handleBeanPopClose(){
      this.showBeanPop = false
    },
    ...mapActions({
      getSessionDetail: "sessionPage/getSessionDetail",
    }),
    followFun(e) {
      let parmas = {
        special_type: 4,
        action: e.isFocus == 0 ? 1 : 2,
        code: e.organCode,
      };
      scMdFunc("allClick", {
        cur_page: "33",
        cur_moudle: "33-1",
        cur_button: "33-1-1",
      });
      if (!e.isLogin) {
        //未登录
        gotoLogin();
      } else {
        indexFocus(parmas).then((res) => {
          if (res.code == 0) {
            if (e.isFocus == 0) {
              this.$toast("关注成功");
            }

            e.isFocus = e.isFocus == 0 ? 1 : 0;
          }
        });
      }
    },
    gotoApp() {
      this.$refs.downloadPop.gotoAppDownload(this.appLink, 0);
    },
    goBack() {
      // this.$router.push({
      //     path: "/"
      // });
      if (document.referrer) {
        window.location.href = document.referrer;
      } else if (window.history.state) {
        this.$router.back();
      } else if (this.$route.query.fromlink) {
        window.location.href = decodeURIComponent(this.$route.query.fromlink);
      } else {
        this.$router.push({
          path: "/",
        });
      }
    },
    podSc() {
      scMdFunc("allClick", {
        cur_page: "33",
        cur_moudle: "33-4",
        cur_button: "33-4-1",
      });
    },
    // 顶部跳转拍卖公司/名称
    toSessionDetail() {
      scMdFunc("allClick", {
        cur_page: "33",
        cur_moudle: "33-2",
        cur_button: "33-2-1",
      });
      if (this.$route.query.from == 1 && this.$route.query.from) {
        return false;
      } else {
        this.$router.push({
          name: "session_detail",
          query: {
            sessionCode: this.$route.params.sessionCode,
            from: this.waterLink,
          },
        });
      }
    },
    alertInfo() {
      scMdFunc("allClick", {
        cur_page: "33",
        cur_moudle: "33-1",
        cur_button: "33-1-2",
      });

      alertInfo("分享时请使用浏览器自身的分享工具");
    },
    // 路由跳转
    toSpecial(item, i) {
      scMdFunc("allClick", {
        cur_page: "33",
        cur_moudle: "33-3",
        cur_button: "33-3-" + (Number(i) + 1),
      });
      // ?from=1（外部应用嵌入态）下不接管点击
      if (this.$route.query.from == 1 && this.$route.query.from) return;
      // 走 SPA router 切换；原 window.location.href 会触发整页跳 + 重走 SSR，弱网下表现为"加载状态一直转"
      // 目标 name=search_special 来自 src/router.js:241；searchSpecial.vue 的 beforeRouteEnter 会标记 isRefresh，activated 重新拉数据
      const query = {};
      if (this.waterLink) query.from = this.waterLink;
      this.$router.push({ name: 'search_special', params: { specialCode: item.specialCode }, query });
    },
    // live_bar 状态取数：统一 Number()。语义与全项目一致——0/1 未开播、2 直播中、3 暂停中、>=4 已结束(回放)
    liveBarStatus(bar) {
      return Number(bar && bar.live_status)
    },
    // ⚠️ 以下四个方法一律按 live_status 判，**不能用 have_review**：
    // have_review 表示"这场直播支持回放"，导览直播即使未开播也恒为 1。
    // 早期实现把 have_review 排在 live_status 之前，导致同一专场里
    // 导览直播的「预告」渲染成灰色、而拍卖直播的「预告」是绿色（实测 PMH215592/71245），
    // 并且未开播的导览直播会被误判成"有回放"→ 按钮直接跳直播间，开播提醒根本点不动。
    // 0918「显示只弹窗」：后台把导览/拍卖直播配成只弹窗时下发 button_type=5。
    // 一律按 button_type 分流，不能只凭 live_status=4 判断——已结束但支持回放的记录也是 4。
    isEndPopup(o) {
      return Number(o && o.button_type) === 5
    },
    // 直播条整条点击：只弹窗态才接管（并阻止冒泡到 <li> 的 toSpecial），
    // 其余状态原样放行，点击仍由右侧按钮或父级专场卡处理
    onLiveEntryRowClick(bar, item, e) {
      if (!this.isEndPopup(bar)) return
      if (e && e.stopPropagation) e.stopPropagation()
      this.onLiveBarClick(bar, item)
    },
    // 只弹窗入口的点击：弹提示并终止后续跳转（文档 5.2 要求优先于原有动作处理）
    openLiveEndedDialog(o) {
      this.liveEnded.popup = (o && o.end_popup) || null
      this.liveEnded.visible = true
    },
    // live_bar 状态徽 className：直播中/暂停中红 / 回放灰 / 预告（未开播）绿
    liveBarTagClass(bar) {
      if (!bar) return ''
      const st = this.liveBarStatus(bar)
      if (st === 2 || st === 3 || bar.status_name == '暂停中') return 'liveEntry__tag--live'
      if (st >= 4) return 'liveEntry__tag--review'
      return 'liveEntry__tag--notice'
    },
    // live_bar 状态徽文案：固定映射避免后端 status_name 漂移（"待直播" → "预告"）
    liveBarTagText(bar) {
      if (!bar) return ''
      const st = this.liveBarStatus(bar)
      if (st === 2) return '直播中'
      // 只弹窗记录也是 live_status=4，但后端下发的是"已结束"，直接用不改写
      if (this.isEndPopup(bar)) return bar.status_name || '已结束'
      if (st >= 4) return '回放'
      if (st === 0 || st === 1) return '预告'
      return bar.status_name || ''
    },
    // live_bar 按钮文案：直播中/暂停中→点击进入；已结束→直播回放；未开播→提醒态
    liveBarBtnText(bar) {
      if (!bar) return ''
      const st = this.liveBarStatus(bar)
      if (st === 3 || bar.status_name == '暂停中') return '点击进入'
      if (st === 2) return bar.button_name || '点击进入'
      if (st >= 4) return bar.button_name || '直播回放'
      // 未开播：以本地 is_join_notice 为准，不用 button_name（后端快照，本地翻转后不会更新）
      return Number(bar.is_join_notice) === 1 ? '已设提醒' : '开播提醒'
    },
    liveBarBtnSubscribed(bar) {
      if (!bar) return false
      if (this.liveBarStatus(bar) >= 2) return false
      return Number(bar.is_join_notice) === 1
    },
    // 位置1（preview_tour_list 导览卡）与 位置2（专场卡 live_bar）是同一条订阅的两个入口：
    // 后端按 (special_id, notice_type) 唯一标识一条提醒（实测导览 notice_type=3、拍卖直播=2，
    // 同一专场两种直播 special_id 相同、notice_type 不同，故必须两个字段一起匹配）。
    // 任一处订阅/取消后同步另一处，避免同页两个入口状态打架。
    syncNoticeState(params, joined) {
      if (!params) return
      const sid = String(params.special_id)
      const nt = String(params.notice_type)
      const val = joined ? 1 : 0
      const hit = (o) => o && String(o.special_id) === sid && String(o.notice_type) === nt
      const list = (this.info && this.info.preview_tour_list) || []
      list.forEach((t) => { if (hit(t)) this.$set(t, 'is_join_notice', val) })
      const specials = this.sessList || []
      specials.forEach((item) => {
        const bars = (item && item.live_bar) || []
        bars.forEach((bar) => { if (hit(bar)) this.$set(bar, 'is_join_notice', val) })
      })
    },
    // live_bar 按钮点击：直播中/回放跳直播链接；未开始切换订阅状态
    // 订阅参考 saas-auction-bid-vue/components/auction/live/preview.vue 的 toggleRemind
    onLiveBarClick(bar,item) {
      if (!bar) return
      // 0918「显示只弹窗」：优先于原有进入/回放/提醒动作，弹提示后终止
      if (this.isEndPopup(bar)) {
        this.openLiveEndedDialog(bar)
        return
      }
      // 直播中 / 回放 → 跳直播链接（live_room_type=2 走 liveGuide，其它走 live）
        
      if (this.liveBarStatus(bar) >= 2 || bar.status_name=='暂停中') {
        if (!bar.special_id) return
            scMdFunc('allClick', {
                cur_page: '33',
                cur_moudle: '33-6',
                cur_button: '33-6-'+ (bar.live_status === 2?'2': '3'),
                auction_specia_performance_id_pk: item.special_id,
                auction_specia_performance_id: item.special_code,
                the_auction_id_pk: item.session_id,
                the_auction_id: item.session_code,
                auction_company_id: item.organ_id,
                auction_company_code: item.organ_code,
                auction_state: item.status == 1 ? '待拍卖' : item.status == 2 ? '预展中' : item.status == 3 ? '待预展' : item.status == 4 ? '拍卖中' : item.status == 5 ? '已结拍' : '',
                auction_type: item.bid_type
         })
        const path = Number(bar.live_room_type) === 2 ? 'liveGuide' : 'live'
        const cloudId = bar.CloudSpecialId == null ? '' : bar.CloudSpecialId
        const roomType = bar.live_room_type == null ? '' : bar.live_room_type
        window.location.href = 'https://m-auction.artron.net/trade/auction/' + path
          + '/' + bar.special_id + '?cloud_special_id=' + cloudId + '&live_room_type=' + roomType
        return
      }
      // 未开始 → 订阅切换。登录鉴权交给后端（与参考实现 saas-auction-bid-vue/components/auction/live/preview.vue 一致）
      if (this._noticeBusy) return // 防抖：请求飞行中再次点击忽略
      const params = {
        special_id: bar.special_id,
        cloud_special_id: bar.CloudSpecialId,
        notice_type: bar.notice_type
      }
      this._noticeBusy = true
      const finish = () => { this._noticeBusy = false }
      const onErrCode = (res) => {
        // 后端返回非 0 时把 message 提示给用户，便于排查"无效果"型问题（如未登录、参数缺失等）
        const msg = (res && (res.message || res.msg)) || '操作失败'
        // 401/未登录：跳登录页
        if (res && (res.code === 401 || res.code === -10 || /登录/.test(msg))) {
          gotoLogin()
          return
        }
        Toast(msg)
      }
      const onNetErr = (err) => {
        Toast((err && err.message) || '网络异常，请重试')
      }
      if (Number(bar.is_join_notice) === 1) {
        cancelSpeRemind(params).then((res) => {
          if (res && res.code === 0) {
            Toast('已取消提醒')
            this.$set(bar, 'is_join_notice', 0)
            this.syncNoticeState(params, false) // 同步位置1 导览卡
          } else {
            onErrCode(res)
          }
        }).catch(onNetErr).then(finish, finish)
      } else {
        // 登录判断（合约 §6.1）：未登录 → 跳登录，不调 gating 不弹弹窗
        if (!Cookies.get('_at_pt_0_')) {
          gotoLogin()
          finish()
          return
        }
         scMdFunc('allClick', {
                cur_page: '33',
                cur_moudle: '33-6',
                cur_button: '33-6-1',
                 auction_specia_performance_id_pk: item.special_id,
                auction_specia_performance_id: item.special_code,
                the_auction_id_pk: item.session_id,
                the_auction_id: item.session_code,
                auction_company_id: item.organ_id,
                auction_company_code: item.organ_code,
                auction_state: item.status == 1 ? '待拍卖' : item.status == 2 ? '预展中' : item.status == 3 ? '待预展' : item.status == 4 ? '拍卖中' : item.status == 5 ? '已结拍' : '',
                auction_type: item.bid_type
         })
        // 首次设置 gating（合约 §6.5）：未初始化 → 拉选择提醒方式弹窗；已初始化 → 直接 add
        decideDialog().then((decision) => {
          if (decision && decision.requireLogin) {
            // 后端表示未登录（cookie 残留场景兜底）
            gotoLogin()
            finish()
            return
          }
          if (decision && decision.needDialog) {
            this.pendingRemind = { params, bar, page: '33' }
            this.reminderDialog = {
              visible: true,
              initialGlobal: decision.switchData.global,
              voiceTips: decision.switchData.voice_tips,
              systemNotifyOn: true
            }
            // 弹窗曝光埋点（sensors §2.3，当前页 33 + -1014）：事件走 allPageView，与鸿蒙/iOS 对齐（2026-06-12 定口径）
            scMdFunc('allPageView', {
              cur_page: '33',
              cur_moudle: '33-1014',
              cur_button: ''
            })
            finish()
          } else {
            this._finalizeAddRemind(params, bar, finish, onErrCode, onNetErr)
          }
        }).catch(() => {
          // fail-open：gating 接口失败时不阻断原流程
          this._finalizeAddRemind(params, bar, finish, onErrCode, onNetErr)
        })
      }
    },
    _finalizeAddRemind(params, bar, finish, onErrCode, onNetErr) {
      addSpeRemind(params).then((res) => {
        if (res && res.code === 0) {
          Toast((res.data && res.data.toast_msg) || bar.notice_text || '提醒已设置')
          this.$set(bar, 'is_join_notice', 1)
          this.syncNoticeState(params, true) // 同步位置1 导览卡 ↔ 位置2 专场卡 live_bar
        } else {
          onErrCode(res)
        }
      }).catch(onNetErr).then(finish, finish)
    },
    onReminderDialogSave(payload) {
      const pending = this.pendingRemind
      if (!pending) {
        this.reminderDialog.visible = false
        return
      }
      saveReminderSwitch(payload).then((res) => {
        if (res && res.code === 0) {
          this.reminderDialog.visible = false
          // set 成功后再补订阅，与鸿蒙端流程一致
          const finish = () => {}
          const onErrCode = (r) => Toast((r && (r.message || r.msg)) || '操作失败')
          const onNetErr = (e) => Toast((e && e.message) || '网络异常，请重试')
          this._finalizeAddRemind(pending.params, pending.bar, finish, onErrCode, onNetErr)
        } else {
          Toast((res && (res.message || res.msg)) || '保存失败，请稍后重试')
        }
      }).catch((e) => {
        Toast((e && e.message) || '网络异常，请重试')
      }).then(() => {
        this.pendingRemind = null
      })
    },
    onReminderDialogClose() {
      this.reminderDialog.visible = false
      this.pendingRemind = null
    },
    onReminderDialogOpenSystemSettings() {
      // H5 端无法直接打开系统通知设置，提示用户手动前往
      Toast('请在系统设置-通知中开启「雅昌拍卖」通知权限')
    },
    // ===== 位置1 导览直播模块（preview_tour_list，Figma 42:1108/1187/1206）=====
    // 统一取数：后端可能下发字符串，一律 Number() 后再比较
    tourLiveStatus(tour) {
      return Number(tour && tour.live_status)
    },
    // 状态标签只在 直播中(2) / 暂停中(3) 出现；未开播/回放/已结束的状态文字走副标题行（tourSubText）
    tourHasBadge(tour) {
      if (!tour) return false
      const st = this.tourLiveStatus(tour)
      return st === 2 || st === 3
    },
    // 标签文案取后端 status_name；后端漏发时按 live_status 兜底，避免直播中的卡片丢掉状态信息
    tourBadgeText(tour) {
      if (!tour) return ''
      return tour.status_name || (this.tourLiveStatus(tour) === 3 ? '暂停中' : '直播中')
    },
    // 副标题：未开播=开播时间；回放/已结束=状态文案；直播中/暂停中不展示（由状态标签承载）
    tourSubText(tour) {
      if (!tour) return ''
      const st = this.tourLiveStatus(tour)
      if (st === 2 || st === 3) return ''
      if (st >= 4) return tour.status_name || '直播回放'
      return tour.start_time || ''
    },
    // 开播提醒按钮只在未开播态出现（button_type 1 开播提醒 / 2 已设提醒）；
    // 3 点击进入 / 4 直播回放 无按钮，整卡可点。
    // live_status 与 button_type 互相校验：直播中/暂停中/回放的卡即使后端误发 button_type=1，
    // 也不能出现「正在直播还让你设开播提醒」的矛盾按钮（设计稿 42:1206 这三态均无按钮）
    isTourNoticeBtn(tour) {
      if (!tour) return false
      const st = this.tourLiveStatus(tour)
      if (st > 1) return false
      const bt = Number(tour.button_type)
      return bt !== 3 && bt !== 4
    },
    // 按钮文案：优先后端 button_name；本地切换订阅状态后以 is_join_notice 为准
    // （设计稿里「开播提醒」与「已设提醒」是同一套样式，只有文案不同，故不再区分 class）
    tourBtnText(tour) {
      if (!tour) return ''
      const subscribed = Number(tour.is_join_notice) === 1
      // button_name 与 button_type 配套下发；本地翻转 is_join_notice 后 button_type 已过期，此时回落固定文案
      if (tour.button_name && Number(tour.button_type) === (subscribed ? 2 : 1)) return tour.button_name
      return subscribed ? '已设提醒' : '开播提醒'
    },
    // 埋点：拍卖会详情页-导览直播入口 33-7
    tourTrack(tour, idx) {
      scMdFunc('allClick', {
        cur_page: '33',
        cur_moudle: '33-7',
        cur_button: '33-7-' + (Number(idx) + 1),
        auction_specia_performance_id_pk: tour.special_id,
        the_auction_id: this.$route.params.sessionCode,
        the_auction_id_pk: this.info && this.info.session_id,
        auction_company_id: this.info && this.info.organ_id,
        auction_company_code: this.info && this.info.organ_code,
        tour_type: tour.tour_type
      })
    },
    // 点击整卡进导览直播间（务必用 preview_tour_list 项自己的 special_id/cloud_special_id）
    onTourCardClick(tour, idx) {
      if (!tour || !tour.special_id) return
      this.tourTrack(tour, idx)
      // 0918「显示只弹窗」：导览卡照常展示但进不去，弹提示（埋点已在上面上报）
      if (this.isEndPopup(tour)) {
        this.openLiveEndedDialog(tour)
        return
      }
      const cloudId = tour.cloud_special_id == null ? '' : tour.cloud_special_id
      window.location.href =
        'https://m-auction.artron.net/trade/auction/liveGuide/' +
        tour.special_id + '?cloud_special_id=' + cloudId + '&live_room_type=2'
    },
    // 按钮点击：进入/回放跳直播间；未开播复用 live_bar 的订阅逻辑（notice_type=3）
    onTourButtonClick(tour, idx) {
      if (!tour) return
      if (!this.isTourNoticeBtn(tour)) {
        this.onTourCardClick(tour, idx)
        return
      }
      if (this._noticeBusy) return
      const params = {
        special_id: tour.special_id,
        cloud_special_id: tour.cloud_special_id,
        // 文档约定导览直播固定 3；后端不下发时兜底，避免传 undefined
        notice_type: tour.notice_type || 3
      }
      this._noticeBusy = true
      const finish = () => { this._noticeBusy = false }
      const onErrCode = (res) => {
        const msg = (res && (res.message || res.msg)) || '操作失败'
        if (res && (res.code === 401 || res.code === -10 || /登录/.test(msg))) { gotoLogin(); return }
        Toast(msg)
      }
      const onNetErr = (err) => { Toast((err && err.message) || '网络异常，请重试') }
      if (Number(tour.is_join_notice) === 1) {
        cancelSpeRemind(params).then((res) => {
          if (this._destroyed) return
          if (res && res.code === 0) {
            Toast('已取消提醒')
            this.$set(tour, 'is_join_notice', 0)
            this.syncNoticeState(params, false) // 同步位置2 专场卡 live_bar
          } else onErrCode(res)
        }).catch(onNetErr).then(finish, finish)
      } else {
        if (!Cookies.get('_at_pt_0_')) { gotoLogin(); finish(); return }
        this.tourTrack(tour, idx)
        decideDialog().then((decision) => {
          if (this._destroyed) return
          if (decision && decision.requireLogin) { gotoLogin(); finish(); return }
          if (decision && decision.needDialog) {
            this.pendingRemind = { params, bar: tour, page: '33' }
            this.reminderDialog = {
              visible: true,
              initialGlobal: decision.switchData.global,
              voiceTips: decision.switchData.voice_tips,
              systemNotifyOn: true
            }
            scMdFunc('allPageView', { cur_page: '33', cur_moudle: '33-1014', cur_button: '' })
            finish()
          } else {
            this._finalizeAddRemind(params, tour, finish, onErrCode, onNetErr)
          }
        }).catch(() => { this._finalizeAddRemind(params, tour, finish, onErrCode, onNetErr) })
      }
    },
    filteData() {
      // this.sessData = this.$store.state["sessionPage"]["data"].extraInfo;
      // // 本次拍卖名称
      // this.sessName = this.$store.state["sessionPage"]["data"].name;
      // this.picUrl = this.$store.state["sessionPage"]["data"].picUrl;
      // // 拍卖列表
      // this.sessList =
      //     this.$store.state["sessionPage"]["data"].specialsList;
      // 微信分享功能+title
      let dome = this.$store.state["sessionPage"]["data"];
      this.info = dome;

      document.title = dome.shareMessage ? dome.shareMessage.title : "";
      // let head = document.getElementsByTagName("head");
      // if (!document.querySelector("meta[name=description]")) {
      //     let meta = document.createElement("meta");
      //     meta.name = "description";
      //     meta.content = dome.meta ? dome.meta.description : "";
      //     head[0].appendChild(meta);
      // } else {
      //     document
      //         .querySelector("meta[name=description]")
      //         .setAttribute(
      //             "content",
      //             dome.meta ? dome.meta.description : ""
      //         );
      // }
      this.getsessionDetail();
    },
    // 调取接口
    getsessionDetail() {
      let that = this;
      this.param.sessionCode = this.$route.params.sessionCode;
      this.param.only_meta = 0;
      if (this.$route.query.from && this.$route.query.from == 1) {
        this.param.show = 1;
        this.param.session_inspect_id = Number(this.$route.query.sessiion_inspect_id);
      }
      // 专场筛选的默认 tab 入口来源：1 近期可拍入口 / 2 已结拍入口 / 0 其他。
      // 后端拿它算 default_tab_type。
      // ⚠️ 不能复用 query.from —— 本页的 from 早就被"预展入口"占用了（见上面几行：from==1 → show/session_inspect_id），
      // 所以入口来源单独走 tab_from，两者互不干扰。
      this.param.from = Number(this.$route.query.tab_from || 0) || 0;
      sessionDetail(this.param).then((res) => {
        if (res.code == 0) {
          // 全部属性
          this.info = res.data;
          console.log(this.info)
          this.sessData = res.data.extraInfo;
          this.sessData.forEach((item) => {
            if (item.label === "拍卖公司") {
              this.companyName = item.text;
            }
          });
          // 本次拍卖名称
          this.sessName = res.data.name;
          this.picUrl = res.data.picUrl;
          // 拍卖列表
          this.sessList = res.data.specialsList;
          // 默认选中的筛选 tab 由后端按入口 from 算好（default_tab_type 恒有值）。
          // 只在首次初始化时采用它：下拉刷新要保持用户当前的选择，不能被重置回默认。
          // 但刷新后当前 tab 已经一个专场都不剩时要回落「全部」，否则用户停在空列表上——
          // 对齐安卓 `if (filteredCount(mCurrentFilter) > 0) mCurrentFilter else FILTER_ALL`。
          if (!this.specialTabActive) {
            this.specialTabActive = Number(res.data.default_tab_type) || 1;
          } else if (
            this.specialTabActive !== 1 &&
            this.countSpecialsByTab(this.specialTabActive) === 0
          ) {
            this.specialTabActive = 1;
          }
          if (this.info.catalog_info_new && this.info.catalog_info_new.length) {
            let catalog = this.info.catalog_info_new[0];
            this.isShowOnline = true;
            this.onlineTitle = catalog.title;
            this.onlineUrl = catalog.link;
            this.onlinePerson = res.data.bid_click_num;
          }
          window.AFedWxShareData = {
            title: this.info.shareMessage ? this.info.shareMessage.title : "",
            imgUrl:
              this.info.shareMessage.pic ||
              "https://pubunder.artron.net/pubimgs/m/wxImgAuc.png",
            desc: this.info.shareMessage.desc || "",
            link: window.location.href,
          };
          getWXConfig(window.AFedWxShareData);
          if (
            this.$route.query.scFrom &&
            this.$route.query.scFrom.split("-").length == 5
          ) {
            const scFromList = this.$route.query.scFrom.split("-");
            scMdFunc("allPageView", {
              from_page: scFromList[0],
              from_module: scFromList[0] + "-" + scFromList[1],
              from_button:
                scFromList[0] + "-" + scFromList[1] + "-" + scFromList[2],
              from_page_pk: this.$route.query.scId || "",
              cur_page: "33",
              magnification: Math.floor(Math.random() * (13 - 7 + 1)) + 7,
            });
          } else {
            scMdFunc("allPageView", {
              cur_page: "33",
              magnification: Math.floor(Math.random() * (13 - 7 + 1)) + 7,
            });
          }
        } else {
          Toast({
            message: "该内容不存在～",
            duration: 2000,
            onClose: function() {
              that.$router.push({
                path: "/",
                query: {
                  from: that.$route.query.from,
                },
              });
            },
          });
        }
      });
    },
    onlineClick() {
      let params = {
        specialCode: this.$route.params.sessionCode,
      };
      setBidClick(params).then((res) => {
        if (res.code == 0) {
          // this.onlinePerson = res.data.bid_click_num;
        }
      });
      // 存句柄，beforeDestroy 里 clearTimeout，避免离开页面后仍然整页跳转
      this._onlineTimer = setTimeout(() => {
        this._onlineTimer = null;
        if (this._destroyed) return;
        window.location.href = this.onlineUrl;
      }, 500);
    },
    // getOnLineAuction(){
    //     let params={
    //         code: this.$route.params.sessionCode
    //     }
    //     onlineAuction(params).then((res)=>{
    //         let data=res.data;
    //         if(data.catalog&&data.catalog.length){
    //             let catalog=data.catalog[0];
    //             this.isShowOnline=true;
    //             this.onlineTitle=catalog.title;
    //             this.onlineUrl=catalog.link;
    //         }
    //     })
    // }
  },
  components: {
    panel,
    DownLoadApp,
    watermark,
    contact,
    beanInstructionsPop,
    beanBtn,
    SelectReminderMethodDialog,
    liveEndedDialog
  },
};
</script>

<style lang="scss" scoped>
@import url("../../assets/css/reset.css");
@import url("../../assets/css/swiper.css");

.header {
  height: 2.2rem;
  background: #ffffff;
  position: relative;
}
.bean-btn-part{
  margin:0 0.2rem;
}
.auction-top-tag {
    top: 0.2rem;
    left: 0.2rem;
    width: 1.9rem;
    height: 0.8rem;
    display: inline-block;
    background-size: 100%;
    background-repeat: no-repeat;
    position: absolute;
    }
    .tag-xianshi {
      background-image: url(../../assets/img/icon_xianshipai@2x.png);
    }
    .tag-tongbu {
      background-image: url(../../assets/img/icon_tongbupai@2x.png);
    }
    .tag-zhibo {
      background-image: url(../../assets/img/icon_zhibo@2x.png);
    }
.wenwubaopi_icon {
    border: none;
    background-image: url(../../assets/img/wenwubaopi_icon@2x.png);
    width: 2.1rem;
    height: 0.7rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    top: 1.2rem;
    left: 0.2rem;
    // transform: translate(-50%, -50%);
    position:absolute;
  }
.greenHeader {
  background: rgba(0, 0, 0, 0);
  z-index: 2;
}

.specialSubjectBox {
  background-image: linear-gradient(#35bd7d, #fff);
  width: 100%;
}

.subjectBox {
  width: 100%;
  background: #fff;
  border-top-right-radius: 1rem;
  border-top-left-radius: 1rem;
  padding: 0.6rem 0.6rem 0.2rem 0.6rem;
}

.subjectContentBox {
  height: 52px;
  background: #f7f8f9;
  border-radius: 6px 6px 6px 6px;
  overflow: hidden;
  padding: 6px;
  box-sizing: border-box;
}

.subjectImg {
  width: 71px;
  height: 40px;
  border-radius: 4px 4px 4px 4px;
  overflow: hidden;
  display: inline-block;
}

.subjectImg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.subjectTextBox {
  display: inline-block;
  font-size: 0.65rem;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000000;
  /* line-height: 16px; */
  vertical-align: top;
}

.subjectTextBox .num {
  font-size: 0.55rem;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #949596;
  line-height: 20px;
}

.header h3 {
  margin-left: 2.2rem;
  margin-right: 2.2rem;
  text-align: center;
  font-size: 0.9rem;
  line-height: 2.2rem;
  color: #27282d;
}

.header .goBack {
  float: left;
  width: 2.2rem;
  height: 2.2rem;
  background: url(../../assets/img/Frame585_new@2x.png) no-repeat;
  background-size: cover;
}

.header .icon_share {
  width: 2.2rem;
  height: 2.2rem;
  float: right;
  background: url("../../assets/img/share_new@2x.png") no-repeat;
  background-size: cover;
}

.greenHeader .goBack {
  float: left;
  width: 2.2rem;
  height: 2.2rem;
  background: url(../../assets/img/Frame585_new@2x.png) no-repeat;
  background-size: cover;
}

.page {
  width: 18.75rem;
  margin: 0 auto;
}
.topBg {
  width: 100%;
  height: 13.5rem;
  filter: blur(10px);
  background: url(../../assets/img/Group437@2x.png) no-repeat;
  background-size: cover;
  position: absolute;
  top: 0;
  z-index: 0;
}
/* 底部黑色内发光（自下而上渐隐）。
   必须用伪元素叠加：.topBg 的 background-image 被模板 :style 内联绑定了 info.top_bg_pic，
   在这里写 background-image 会被内联样式整个覆盖掉。
   注意可见范围——.speInfo 白色面板从 topBg 的 ~53% 处开始遮挡，渐变最深的底部其实看不到，
   页面上呈现的是渐变的中上段。 */
.topBg::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.95) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  pointer-events: none;
}
.speDetail {
  position: relative;
  margin-top: -1px;
}

.speDetail .imgCenter {
  display: flex;
  width: 4rem;
  height: 4rem;
  background: #ffffff;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0rem 0rem 0.35rem 0rem rgba(0, 0, 0, 0.35);
  position: absolute;
  top: 0;
  left: 0.5rem;
}

.speDetail .imgCenter .bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  transform: scale(1.2);
}
.speDetail .imgCenter .poster {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
.speDetail .imgCenter img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.speDetail .speName {
  padding-left: 5.35rem;
  padding-right: 2.75rem;
  // height: 1.15rem;
  margin-bottom: 0.5rem;
  // background: #35BD7D;
  font-size: 0.8rem;
  font-weight: 400;
  /* 白字：.speInfo 的白底被注释掉后，头部文字直接压在 .topBg 背景图上，
     配合 .topBg::after 的黑色渐变保证可读性 */
  color: #fff;
  line-height: 1.1rem;
}

.followBox {
  position: absolute;
  right: 2.3rem;
  top: 0.5rem;

  img {
    width: 1.2rem;
    vertical-align: top;
  }
}

.speDetail .speInfo {
  position: relative;
  padding-top: 0.4rem;
  padding-bottom: 0.3rem;
  padding-left: 5.35rem;
  padding-right: 1.55rem;
  border-top-right-radius: 2rem;
  border-top-left-radius: 2rem;
  // background: #fff;
  font-size: 0.55rem;
  font-weight: 400;
  /* 次级信息用 75% 白：保持与 .speName 纯白标题的层级差（原来是 #949596 灰对 #000 黑） */
  color: rgba(255, 255, 255, 0.75);
  line-height: 0.9rem;
}

.speDetail .speInfo p {
  margin-bottom: 0.25rem;
  overflow: hidden; //多出部分隐藏
  white-space: nowrap; //一行显示
  text-overflow: ellipsis; //是否显示省略号
}

.speDetail .speInfo .moreBtn {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  margin-top: -0.4rem;
  width: 0.8rem;
  height: 0.8rem;
  /* 白色箭头：头部信息区压在 .topBg 背景图上，灰箭头(#949596)在暗底上发闷。
     复用项目已有的 icon_white_arrow.png（32×32 纯白右箭头，searchSpecial.vue 亦在用），不新增素材 */
  background: url(../../assets/img/icon_white_arrow.png) no-repeat;
  background-size: cover;
}

.speBox {
  margin-top: 0.25rem;
  background: #ffffff;
  padding-bottom: 0.5rem;
}

.speBox .swiper-slide {
}

.speBox .swiper-slide li {
  height: 2.3rem;
  padding: 0 0.6rem 0 0.75rem;
}

.speBox .swiper-slide a {
  display: block;
  height: 100%;
  position: relative;
}

.speBox .swiper-slide .icon {
  position: absolute;
  top: 0.55rem;
  left: 0;
  width: 1.2rem;
  height: 1.2rem;
  background: url(../../assets/img/icon_pai@2x.png) no-repeat;
  background-size: cover;
}

.speBox .swiper-slide .text {
  display: block;
  width: 13rem;
  margin: 0 auto;
  font-size: 0.7rem;
  line-height: 2.3rem;
  color: #27282e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.speBox .swiper-slide .button {
  position: absolute;
  right: 0.6rem;
  top: 0.65rem;
  width: 2.2rem;
  height: 1rem;
  background: #ffffff;
  border-radius: 0.53rem;
  border: 0.03rem solid #18bd6f;
  text-align: center;
  line-height: 1rem;
  font-size: 0.6rem;
  color: #18bd6f;
}

.speBox .swiper-pagination {
  position: relative;
}

/deep/ .speBox .swiper-pagination-bullet {
  width: 0.2rem;
  height: 0.2rem;
  background: #dddee3;
  opacity: 1;
}

/deep/ .speBox .swiper-pagination-bullet-active {
  width: 0.6rem;
  border-radius: 0.1rem;
  background: #18bd6f;
}

/deep/ .speBox.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 0;
}

.speList {
  background: #ffffff;
  position: relative;
}

.speList ul {
  padding: 0 0.75rem;
}

.speList li {
  padding: 0.75rem 0;
  border-bottom: 0.05rem solid #dddee3;
}

.speList li:last-child {
  border-bottom: none;
}

.speList li dt {
  width: 3.75rem;
  height: 5rem;
  border-radius: 0.2rem;
  overflow: hidden;
  position: relative;
  float: left;
}

.speList li dt .imgCenter {
  width: 100%;
  height: 100%;
  display: flex;
  background: #f5f5f5;
}

.speList li dt .imgCenter img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.speList li dd {
  margin-left: 4.25rem;
}

.speList li dd h3 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-size: 0.8rem;
  line-height: 1.1rem;
  color: #27282d;
}

.speList li dd h3 .status {
  width: 1.9rem;
  height: 0.7rem;
  display: inline-block;
  vertical-align: -0.1rem;
  margin-right: 0.2rem;
}

// 待拍卖
.speList li dd h3 .status1 {
  background: url(../../assets/img/icon_list_tag_green@2x.png) no-repeat;
  background-size: cover;
}

// 拍卖中
.speList li dd h3 .status2 {
  background: url(../../assets/img/icon_list_tag_red@2x.png) no-repeat;
  background-color: rgba(235, 81, 100, 0.1);
  background-position: center;
  background-size: 80% 70%;
  height: 0.8rem;
}

// 已结拍
.speList li dd h3 .status3 {
  background: url(../../assets/img/icon_list_tag_grey@2x.png) no-repeat;
  background-color: rgba(188, 189, 190, 0.2);
  background-position: center;
  background-size: 80% 70%;
  height: 0.8rem;
}

// 预展中
.speList li dd h3 .status4 {
  background: url(../../assets/img/icon_list_tag_green.png) no-repeat;
  background-color: rgba(54, 153, 114, 0.1);
  background-position: center;
  background-size: 80% 70%;
  height: 0.8rem;
}

// 待预展
.speList li dd h3 .status5 {
  background: url(../../assets/img/icon_list_tag_grey@2x.png) no-repeat;
  background-color: rgba(188, 189, 190, 0.2);
  background-position: center;
  background-size: 80% 70%;
  height: 0.8rem;
}
// 暂停
.speList li dd h3 .status6 {
  background: #f2f2f2;
  text-align: center;
  color: #34886b;
  font-size: 0.55rem;
  line-height: 0.9rem;
  height: 0.8rem;
  vertical-align: 0;
}
.speList li dd .tags {
 margin-top: 0.3rem;
  margin-bottom: 0.9rem;
  // height: 0.9rem;
  font-size: 0;
  display: flex;
  // align-items: center;
  flex-wrap: wrap;
  overflow: hidden;
  height: 0.9rem;
}
.bidIcon {
  height: 0.67rem;
  margin-right: 0.3rem;
}
.speList li dd .tags span {
  padding: 0 0.2rem;
  height: 0.67rem;
  display:flex ;
  align-items: center;
  border-radius: 0.1rem;
  border: 0.03rem solid #d8d8d8;
  font-size: 0.45rem;
  color: #969696;
  margin-right: 0.3rem;
  margin-bottom: 0.2rem;
}
.speList li dd .tags .tagStyle {
  color: #ffffff;
  border: 0;
  border-radius: 0.15rem 0.15rem 0.15rem 0.15rem;
   background: url('../../assets/img/commission_icon.png');
  background-size: 100% 100%;
}
.speList li dd .tags .tagStyle2 {
  color: #ffffff;
  border: 0;
  background: url('../../assets/img/commission_icon2.png');
  background-size: 100% 100%;
  border-radius: 0.15rem 0.15rem 0.15rem 0.15rem;
}
.speList li dd .tags .label-butie {
  color: #F6344B;
  width: 2.5rem;
  height: 0.7rem;
  font-weight: 600;
  padding-right: 0.05rem;
  background: url('../../assets/img/tag/commission_icon1Num.png');
  background-size: 100% 100%;
  border-radius: 0.15rem 0.15rem 0.15rem 0.15rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: .5rem;
}
.speList li dd .tags .label-butie.label-butieLong {
  width: 2.9rem;
}
.speList li dd .tags .label-butieNull {
  color: #fff;
  width: 2rem;
  height: 0.7rem;
  padding: 0.12rem 0.2rem 0.08rem 0.2rem;
  background: url('../../assets/img/tag/commission_icon1Null.png');
  background-size: 100% 100%;
  border-radius: 0.15rem 0.15rem 0.15rem 0.15rem;
  display: flex;
  align-items: center;
  font-size: .5rem;
}
.speList li dd .tags .label-butie2 {
  color: #6D5AFF;
  font-weight: 600;
  width: 2.5rem;
  height: 0.7rem;
  padding-right: 0.05rem;
  background: url('../../assets/img/tag/commission_iconNum.png');
  background-size: 100% 100%;
  border-radius: 0.15rem 0.15rem 0.15rem 0.15rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: .5rem;
}
.speList li dd .tags .label-butie2.label-butie2Long {
  width: 2.9rem;
}
.speList li dd .tags .label-butie2Null {
  color: #fff;
  width: 2rem;
  height: 0.7rem;
  padding: 0.12rem 0.2rem 0.08rem 0.2rem;
  background: url('../../assets/img/tag/commission_iconNull.png');
  background-size: 100% 100%;
  border-radius: 0.15rem 0.15rem 0.15rem 0.15rem;
  display: flex;
  align-items: center;
  font-size: .5rem;
}
.speList li dd .tags .label-baozhengjin {
  color: #6b6c6c;
  border: 0.02rem solid rgba(0,0,0,0.2);
  background: none;
  border-radius: 0.15rem;
}
.speList li dd .tags .nullBean_icon {
  border: none;
  background-image: url(../../assets/img/tag/nullBean.png);
  width: 2.7rem;
  height: 0.7rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.speList li dd .tags .tagStyle3 {
  color: #fff;
  border: 0;
  width: 2.2rem;
  border-radius: 0.15rem;
  background: url('../../assets/img/commission_icon3.png');
  background-size: 100% 100%;
}
.speList li dd .tags .tagStyle4 {
  color: #fff;
   width: 2.5rem;
  border: 0;
  border-radius: 0.15rem;
  background: url('../../assets/img/commission_icon4.png');
  background-size: 100% 100%;
}


.speList li dd .speItem {
  font-size: 0.65rem;
  color: #969696;
  line-height: 0.9rem;
}

.speList li dl {
  overflow: hidden;
}

.speList li dd .speItem .item {
  margin-bottom: 0.15rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-left: 0.95rem;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: 0.65rem;
}

.speList li dd .speItem:last-child .item {
  margin-bottom: 0;
}

.speList li dd .speItem .icon1 {
  background-image: url(../../assets/img/icon_lot.png);
}

.speList li dd .speItem .icon2 {
  background-image: url(../../assets/img/icon_clock.png);
}

.speList li dd .speItem .icon3 {
  background-image: url(../../assets/img/icon_list_add_light@2x.png);
}

.speList li dt .num {
  position: absolute;
  top: 0.2rem;
  left: 0.2rem;
  padding: 0 0.2rem;
  border-radius: 0.1rem;
  background: #101415;
  font-size: 0.6rem;
  line-height: 0.75rem;
  color: #ffffff;
}

.speList li dt .HDPic {
  position: absolute;
  top: 0;
  right: 0;
  width: 1.3rem;
  height: 0.6rem;
  background: url(../../assets/img/hd_list_icon.png) no-repeat;
  background-size: 100% 100%;
}

.speList li dt .live {
  position: absolute;
  bottom: 0;
  left: 0;

  width: 100%;
  height: 1rem;
  background: #18bd6f url(../../assets/img/live.gif) no-repeat;
  font-size: 0.55rem;
  line-height: 1rem;
  background-size: cover;
  color: #ffffff;
}

.speList li dt .review {
  position: absolute;
  bottom: 0;
  left: 0;
  text-align: center;
  width: 100%;
  height: 1rem;
  background: rgba(0, 0, 0, 0.85);
  font-size: 0.55rem;
  line-height: 1rem;
  color: #ffffff;
}
/* ===== 位置1 导览直播模块（preview_tour_list）Figma 42:1108 / 42:1187 / 42:1206 ===== */
/* 不设 z-index：.speDetail .imgCenter 海报是 absolute z-index:2，短标题时应压在本模块之上 */
.previewTourModule {
  position: relative;
  padding: 0 0.75rem 0.5rem;
}
.previewTourScroll {
  display: flex;
  gap: 0.6rem;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.previewTourScroll::-webkit-scrollbar {
  display: none;
}
.previewTourScroll.is-single .previewTourCard {
  width: 100%;
  flex: 0 0 100%;
}
/* 深色渐变卡：#222 打底 + 右侧 rgba(255,0,75,.5)→#222 的渐变叠加(图层不透明度 .2) + #FFA3B3@30% 描边 */
.previewTourCard {
  flex: 0 0 auto;
  width: 10rem;
  height: 3.8rem;
  display: flex;
  align-items: stretch;
  background-color: #222222;
  background-image: linear-gradient(
    to left,
    rgba(255, 0, 75, 0.1) 0%,
    rgba(255, 0, 75, 0) 60%
  );
  border: 0.05rem solid rgba(255, 163, 179, 0.3);
  border-radius: 0.6rem;
  overflow: hidden;
  box-sizing: border-box;
}
/* 封面贴左满高、无内边距 */
.previewTourCard__cover {
  width: 2.9rem;
  flex-shrink: 0;
  align-self: stretch;
  background: #2c2c2c;
}
.previewTourCard__cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.previewTourCard__main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.1rem;
  padding: 0.2rem 0.6rem;
  box-sizing: border-box;
}
/* 状态标签：仅直播中(2)/暂停中(3)，红字 + 10% 红底 */
.previewTourCard__badge {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 0.1rem;
  padding: 0.1rem 0.2rem;
  border-radius: 0.15rem;
  font-size: 0.55rem;
  line-height: 0.75rem;
  color: #f6344b;
  background: rgba(235, 81, 100, 0.1);
  white-space: nowrap;
}
.previewTourCard__bars {
  display: inline-flex;
  align-items: flex-end;
  gap: 0.06rem;
  height: 0.5rem;
  flex-shrink: 0;
}
.previewTourCard__bars em {
  display: inline-block;
  width: 0.07rem;
  height: 100%;
  background: currentColor;
  border-radius: 0.05rem;
  animation: previewTourBars 0.9s infinite ease-in-out;
}
.previewTourCard__bars em:nth-child(1) { height: 40%; animation-delay: 0s; }
.previewTourCard__bars em:nth-child(2) { height: 90%; animation-delay: 0.15s; }
.previewTourCard__bars em:nth-child(3) { height: 60%; animation-delay: 0.3s; }
@keyframes previewTourBars {
  0%, 100% { transform: scaleY(1); }
  50% { transform: scaleY(0.4); }
}
.previewTourCard__title {
  font-size: 0.7rem;
  line-height: 0.98rem;
  color: #ffffff;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/* 多卡且无按钮时标题两行截断（PRD：导览标题最多两行，超出打点） */
.previewTourCard__title.is-clamp2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.previewTourCard__time {
  font-size: 0.6rem;
  line-height: 0.84rem;
  color: rgba(255, 255, 255, 0.7);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/* 开播提醒按钮：白 10% 底 + 白 50% 描边 + 白字 */
.previewTourCard__btn {
  flex-shrink: 0;
  height: 1.15rem;
  line-height: 1.05rem;
  text-align: center;
  background: rgba(255, 255, 255, 0.1);
  border: 0.05rem solid rgba(255, 255, 255, 0.5);
  border-radius: 0.3rem;
  color: #ffffff;
  font-size: 0.6rem;
  box-sizing: border-box;
}
/* 单卡（宽卡）：按钮独立成右侧一列，垂直居中 */
.previewTourCard__btn--side {
  align-self: center;
  flex-shrink: 0;
  margin: 0 0.6rem 0 0;
  width: 3.4rem;
  height: 1.25rem;
  line-height: 1.15rem;
}

/* ===== 直播入口 ===== */
.liveEntryList {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 0.4rem 0.5rem 0;
}

.liveEntry {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}

.liveEntry__left {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 0.5rem;
  min-width: 0;
}

.liveEntry__title {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.15rem;
  flex-shrink: 0;
  /* 不再固定 4.4rem：直播中 + 跳动条 占用更宽，让标题随内容伸缩 */
}

.liveEntry__name {
  font-family: 'Alimama ShuHeiTi', 'PingFang SC', sans-serif;
  font-weight: 700;
  font-size: 0.65rem;
  line-height: 1.23em;
  color: #000000;
}

.liveEntry__tag {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 0.1rem;
  height: 0.75rem;
  padding: 0.075rem 0.2rem 0.1rem;
  border-radius: 0.15rem;
  font-size: 0.5rem;
  font-weight: 550;
  white-space: nowrap;
}

.liveEntry__tag--live {
  background: rgba(246, 52, 75, 0.10);
  color: #F6344B;
}

.liveEntry__tag--review {
  background: rgba(0, 0, 0, 0.05);
  color: #6B6C6C;
}

.liveEntry__tag--notice {
  background: rgba(0, 155, 95, 0.1);
  color: #009B5F;
}

.liveEntry__tagText {
  display: inline-block;
  line-height: 1;
  margin-top: 0.1rem;
}

.liveEntry__tagBars {
  display: inline-flex;
  align-items: flex-end;
  gap: 0.05rem;
  height: 0.45rem;

  em {
    display: inline-block;
    width: 0.07rem;
    background: currentColor;
    border-radius: 0.05rem;
    animation: liveEntryBars 0.9s infinite ease-in-out;
  }

  em:nth-child(1) { height: 40%; animation-delay: 0s; }
  em:nth-child(2) { height: 90%; animation-delay: 0.15s; }
  em:nth-child(3) { height: 60%; animation-delay: 0.3s; }
}

@keyframes liveEntryBars {
  0%, 100% { transform: scaleY(1); }
  50% { transform: scaleY(0.4); }
}

.liveEntry__time {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.3rem;
  flex: 1;
  min-width: 0;

  span {
    font-size: 0.65rem;
    font-weight: 400;
    color: #000000;
    line-height: 1.4em;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.liveEntry__clock {
  width: 0.6rem;
  height: 0.6rem;
  flex-shrink: 0;
}

.liveEntry__btn {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0.6rem;
  border-radius: 2rem;
  border: 0.025rem solid rgba(0, 0, 0, 0.2);
  font-size: 0.6rem;
  font-weight: 400;
  color: #353637;
  line-height: 1.4em;
  white-space: nowrap;
  cursor: pointer;

  /* 已订阅：视觉淡化但仍可点击（切换为取消提醒），与设计稿 755:7594 "已设提醒" 状态一致 */
  &.is-subscribed {
    color: #B0B1B1;
    border-color: rgba(0, 0, 0, 0.08);
  }
}

.liveEntry__divider {
  height: 0;
  border-bottom: 0.025rem solid rgba(0, 0, 0, 0.1);
}

.statistics {
  background-color: #fff;
  border-top-right-radius: 2rem;
  border-top-left-radius: 2rem;
  padding: 0.6rem 0.8rem 0;
  position: relative;
  z-index: 2;
  margin-top: 0.2rem;
  /* 「共X场」与筛选栏同一行：左文右筛选。
     没有筛选栏时 .statistics-total 单独占一行，视觉与改动前一致 */
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* 「共X场」：安卓 cardinalNumber 是 #353637 / 14dp，数字另外加粗置黑 */
.statistics-total {
  flex: 1;
  min-width: 0;
  font-size: 0.7rem;
  color: #353637;

  .statistics-num {
    font-weight: 600;
    color: #000000;
  }
}
/* 分段筛选控件：外层灰底胶囊，选中项白底。
   尺寸逐条对齐安卓 view_auction_detail_top.xml + 两个 shape：
     容器 llSpecialFilter  background #F5F5F5 / corners 8dp / padding 2dp
     每个 tab             padding 7dp 左右 · 3dp 上下 / textSize 12sp / marginStart 2dp
     选中 shape_special_filter_tab_selected  白底 / corners 6dp / 文字 #353637（不加粗）
     未选中               无背景 / 文字 #949596
   ⚠️ 圆角别再写 2rem：安卓是 8dp/6dp 的小圆角矩形，不是全圆的胶囊。 */
.special-filter {
  flex: none;
  display: flex;
  align-items: center;
  padding: 0.1rem;
  border-radius: 0.4rem;
  background: #f5f5f5;

  &__item {
    padding: 0.15rem 0.35rem;
    border-radius: 0.3rem;
    font-size: 0.6rem;
    line-height: 1.4em;
    color: #949596;
    white-space: nowrap;
    cursor: pointer;

    & + & {
      margin-left: 0.1rem;
    }

    &.is-active {
      background: #ffffff;
      color: #353637;
    }
  }
}
/* 排查面板（?debug=1 才渲染，临时，定位完删）。故意做得显眼，避免被误认为正式 UI */
.tab-debug {
  margin: 0.4rem 0.65rem;
  padding: 0.5rem 0.6rem;
  border: 0.1rem dashed #ff5f00;
  border-radius: 0.4rem;
  background: #fffdf5;
  font-size: 0.6rem;
  line-height: 1.5em;
  color: #353637;
  word-break: break-all;

  &__title {
    margin-bottom: 0.3rem;
    font-weight: 600;
    color: #ff5f00;
  }
  &__row {
    display: flex;

    b {
      flex: none;
      width: 8rem;
      color: #6b6b6b;
      font-weight: 400;
    }
    span {
      flex: 1;
    }
  }
}
.onlineAuction {
  background: #ffffff;
  padding: 0 0.65rem 0.25rem;
  border-top: 1px solid #f8f8f8;
  border-bottom: 1px solid #f8f8f8;
}

.onlineAuction .auctionView {
  display: block;
  line-height: 1.2rem;
  font-size: 0.7rem;
  background: url(../../assets/img/icon_pai@2x.png) no-repeat 0 center;
  background-size: auto 1.2rem;
  font-family: Helvetica, STHeiTi, Arial, sans-serif;
  padding: 0.55rem 0 0.55rem 1.45rem;
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
}

.onlineAuction .auctionView .auctionTitle {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.onlineAuction .auctionView .auctionBtn {
  display: inline-block;
  border: 0.03rem solid #18bd6f;
  border-radius: 0.6rem;
  text-align: center;
  font-size: 0.5rem;
  color: #18bd6f;
  padding: 0 0.5rem;
  white-space: nowrap;
  min-width: 2.2rem;
}

.podWrap {
  position: fixed;
  right: 0;
  bottom: 5.35rem;
  width: 3.2rem;
  height: 6.4rem;
  background: transparent;
  z-index: 30;
}
</style>
